module.exports = __webpack_public_path__ + "static/image-cah-f17d64b0e57131f23a3d8185ee74f287.jpg";